import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes: Array<RouteConfig> = [
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/indexView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/shoplist',
    name: 'shoplist',
    component: () => import('../views/shoplistView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/scan',
    name: 'scan',
    component: () => import('../views/scanView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/loginView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/billUpload',
    name: 'billUpload',
    component: () => import('../views/billUploadView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/myView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/questionnaireDetail',
    name: 'questionnaireDetail',
    component: () => import('../views/questionnaireDetailView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/questionnaireDetailDone',
    name: 'questionnaireDetailDone',
    component: () => import('../views/questionnaireDetailDoneView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/couponsList',
    name: 'couponsList',
    component: () => import('../views/couponsListView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/billList',
    name: 'billList',
    component: () => import('../views/billListView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/billUploadInfo',
    name: 'billUploadInfo',
    component: () => import('../views/billUploadInfoView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/MapView.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/refresh',
    name: 'refresh',
    component: () => import('../views/refreshView.vue'),
    meta: {
      title: '',
    },
  },

  {
    path: '/business/login',
    name: 'business_login',
    component: () => import('../views/business/loginView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '登录',
    },
  },
  {
    path: '/business/salesRegister',
    name: 'business_salesRegister',
    component: () => import('../views/business/salesRegisterView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '注册商户',
    },
  },
  {
    path: '/business/add',
    name: 'business_salesAdd',
    component: () => import('../views/business/salesAddView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '商户数据提交',
    },
  },
  {
    path: '/business/userChange',
    name: 'business_userChange',
    component: () => import('../views/business/userChangeView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '商户信息修改',
    },
  },
  {
    path: '/business/salesEdit',
    name: 'business_salesEdit',
    component: () => import('../views/business/salesEditView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '商户数据提交记录',
    },
  },
  {
    path: '/business/saleDetailAdd',
    name: 'business_saleDetailAdd',
    component: () => import('../views/business/saleDetailAddView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '商户明细数据提交',
    },
  },
  {
    path: '/business/salesHistory',
    name: 'business_salesHistory',
    component: () => import('../views/business/salesHistoryView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '历史数据',
    },
  },
  {
    path: '/business/salesHistoryDetail',
    name: 'business_salesHistoryDetail',
    component: () => import('../views/business/salesHistoryDetailView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '历史数据详情',
    },
  },
  {
    path: '/business/statistic',
    name: 'business_statistic',
    component: () => import('../views/business/statisticView.vue'),
    meta: {
      title: store.state.resources.Business_Title ? store.state.resources.Business_Title : '数据统计',
    },
  },
  {
    path: '/guess/index',
    name: 'guess_index',
    component: () => import('../views/guess/indexView.vue'),
    meta: {
      title: '宁波消费“潮头榜”竞猜达人-首页',
    },
  },
  {
    path: '/guess/my',
    name: 'guess_my',
    component: () => import('../views/guess/myView.vue'),
    meta: {
      title: '宁波消费“潮头榜”竞猜达人-我的竞猜',
    },
  },
  {
    path: '/guess/rule',
    name: 'guess_rule',
    component: () => import('../views/guess/ruleView.vue'),
    meta: {
      title: '宁波消费“潮头榜”竞猜达人-活动规则',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});
/*路由守卫拦截器*/
router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;

  if (to.matched.length !== 0) {
    next();
  }
});

export default router;
